module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-IGZO-High-Resolution-4.decc7881.jpeg";